import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { School, Sparkles, ArrowRight } from 'lucide-react';

export default function InvitePage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [schoolName, setSchoolName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInvite = async () => {
      try {
        const { data } = await api.get(`/invite/${slug}`);
        setSchoolName(data.name);
      } catch (err) {
        setError(err.response?.data?.detail || 'Enlace inválido o expirado.');
      } finally {
        setLoading(false);
      }
    };
    fetchInvite();
  }, [slug]);

  if (loading) {
    return <div className="min-h-screen bg-[#030712] flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-slate-700 border-t-emerald-500 rounded-full animate-spin" />
    </div>;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#030712] flex items-center justify-center p-6 text-center">
        <div className="bg-slate-900 border border-slate-800 p-8 rounded-2xl max-w-md">
          <p className="text-red-400 font-bold mb-2">Ups, algo salió mal</p>
          <p className="text-slate-400 text-sm mb-6">{error}</p>
          <button onClick={() => navigate('/')} className="bg-slate-800 hover:bg-slate-700 text-white px-6 py-2 rounded-xl transition-all">
            Ir al inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#030712] flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-600/10 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="bg-slate-900/80 backdrop-blur-xl border border-slate-800 p-8 md:p-12 rounded-3xl w-full max-w-lg text-center relative z-10 shadow-2xl">
        <div className="w-16 h-16 bg-emerald-500/10 rounded-2xl flex items-center justify-center mb-6 border border-emerald-500/20 mx-auto">
          <School size={32} className="text-emerald-400" />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-3">Invitación Especial</h1>
        <p className="text-slate-300 text-lg mb-8 leading-relaxed">
          <strong className="text-emerald-400">{schoolName}</strong> te ha invitado a unirte a DinamiClass con una cuenta <strong>Premium institucional</strong>.
        </p>
        
        <div className="bg-slate-950 border border-slate-800 rounded-xl p-4 mb-8 text-left space-y-3">
          <div className="flex items-center gap-3 text-sm text-slate-300">
            <Sparkles size={16} className="text-blue-400" /> Dinámicas con IA sin límites
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-300">
            <Sparkles size={16} className="text-blue-400" /> Cuenta verificada automáticamente
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-300">
            <Sparkles size={16} className="text-blue-400" /> Sin costo para vos
          </div>
        </div>

        <button
          onClick={() => navigate(`/auth?invite=${slug}`)}
          className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 rounded-xl transition-all flex items-center justify-center gap-2 shadow-lg shadow-emerald-900/20"
        >
          Aceptar Invitación y Crear Cuenta <ArrowRight size={18} />
        </button>
      </div>
    </div>
  );
}
